
import React from "react";

export const columnWeighingStation = [
    {
        title: "Mã trạm cân",
        dataIndex: "weighingStationCode",
        width: "20%",
    },
    {
        title: "Trạm cân",
        dataIndex: "weighingStationName",
    },

    {
        title: "Địa chỉ",
        dataIndex: "address",
    },
    {
        title: "Trạng thái",
        dataIndex: "statusFormat",
    }
];
